import LegalPage from '../../components/common/LegalPage';

const SECTIONS = [
  {
    title: 'General Disclaimer',
    body: `The information provided on the Bhadralok website is for general informational and commercial purposes only. While we strive to keep all information accurate, complete, and current, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information, products, services, or related graphics on our website.`,
  },
  {
    title: 'Product Information Disclaimer',
    body: `Product descriptions, images, dimensions, and material information are provided to the best of our knowledge and are as accurate as possible. However:

• Colors may appear differently on your screen due to monitor calibration differences
• Product dimensions may have minor variations due to the handcrafted nature of our garments (±1–2 cm)
• Natural fabrics may have slight variations in texture and color between batches
• Care instructions are recommendations; individual results may vary`,
  },
  {
    title: 'Pricing Disclaimer',
    body: `All prices on our website are in Indian Rupees (INR) and include applicable GST unless otherwise stated. We reserve the right to change prices at any time without prior notice. In the event of a pricing error, we reserve the right to cancel orders placed at incorrect prices, with full refunds issued.

International customers are responsible for any customs duties, taxes, or import fees levied by their country's authorities.`,
  },
  {
    title: 'User Reviews Disclaimer',
    body: `Product reviews and ratings on our website are submitted by verified customers and represent individual opinions. Bhadralok does not endorse, verify, or guarantee the accuracy of user-generated reviews. We reserve the right to remove reviews that violate our content guidelines.`,
  },
  {
    title: 'External Links Disclaimer',
    body: `Our website may contain links to external websites for your convenience. These links do not constitute endorsements of those websites or their content. Bhadralok has no control over the content, privacy policies, or practices of third-party websites and accepts no responsibility for them.`,
  },
  {
    title: 'Health and Allergy Disclaimer',
    body: `Some of our products contain natural dyes, adhesives, or embellishments that may cause allergic reactions in sensitive individuals. We recommend checking material compositions on product pages if you have known sensitivities. If you experience any adverse reaction, discontinue use immediately and consult a medical professional.`,
  },
  {
    title: 'Limitation of Liability',
    body: `To the fullest extent permitted by applicable law, Bhadralok, its owners, employees, and affiliates shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from your use of our website or products. This includes, without limitation, damages for loss of profits, goodwill, data, or other intangible losses.`,
  },
  {
    title: 'No Professional Advice',
    body: `Content on the Bhadralok Adda (blog) and other informational pages is for general interest and entertainment only. It does not constitute professional fashion, legal, financial, or other expert advice. Always seek appropriate professional guidance for specific decisions.`,
  },
  {
    title: 'Changes to This Disclaimer',
    body: `We reserve the right to update or modify this Disclaimer at any time without prior notice. Your continued use of our Services after any changes constitutes acceptance of the updated Disclaimer. We recommend reviewing this page periodically.`,
  },
  {
    title: 'Contact',
    body: `If you have any questions or concerns about this Disclaimer, please contact us:

Email: legal@bhadralok.com
Address: Bhadralok Studio, 12/3 College Street, North Kolkata, West Bengal — 700073`,
  },
];

export default function Disclaimer() {
  return (
    <LegalPage
      title="DISCLAIMER"
      label="Important Notice"
      lastUpdated="January 1, 2025"
      intro="This Disclaimer outlines the limitations of liability and other important notices regarding the use of Bhadralok's website, products, and services."
      sections={SECTIONS}
    />
  );
}
